'use client';

import { forwardRef } from 'react';

import { NavigationMenu } from '@wwe-portal/ui/components/navigation/navigation';
import { StickyTopMenu } from '@wwe-portal/ui/components/navigation/stick-menu';
import { SECTION_IDS } from '@wwe-portal/web/utils/club-store/constants';
import { useNavigation } from '@wwe-portal/ui/components/navigation';

export interface ClubStoreNavigationProps {
  className?: string;
}

const menuItems = [
  {
    id: SECTION_IDS.mission,
    label: 'Missions',
  },
  {
    id: SECTION_IDS.fuseUp,
    label: 'Fuse Up',
  },
  {
    id: SECTION_IDS.recruitment,
    label: 'Superstar',
  },
  {
    id: SECTION_IDS.items,
    label: 'Drops',
  },
];

export const ClubStoreNavigation = forwardRef<
  HTMLDivElement,
  ClubStoreNavigationProps
>(({ className }, ref) => {
  const { activeId, lockedActiveId, handleItemClick } =
    useNavigation(menuItems);

  return (
    <StickyTopMenu className={className} ref={ref}>
      <NavigationMenu
        activeId={lockedActiveId ?? activeId}
        className="gap-2.5 px-5 xl:px-[30px]"
        items={menuItems}
        onClick={handleItemClick}
      />
    </StickyTopMenu>
  );
});

ClubStoreNavigation.displayName = 'ClubStoreNavigation';
